module.exports = __webpack_public_path__ + "static/media/country_pr.2b18fee9.webp";